import React from "react";
import { FlexContainer } from "src/components";
import TextAlignSelector from "../components/TextAlignSelector";
import { TextLabel } from "../../style";

export const TextAlignmentField = ({ value, onChange }) => {

    return (
        <FlexContainer>
            <TextLabel color="#000000" fontWeight="bold" fontSize="16px">
                Text Alignment </TextLabel>
            <TextAlignSelector value={value} onChange={(e) => onChange(e)} />
        </FlexContainer>
    );
};
